import React, { useEffect, useState } from 'react';
import './CookieConsent.scss';

const CookieConsent = () => {
  const [isConsentGiven, setIsConsentGiven] = useState(
    localStorage.getItem('cookieConsent')
  );

  const initializeGoogleAnalytics = (analyticsConsent, adsConsent) => {
    // Ensure the dataLayer exists
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    // Set default consent state BEFORE pushing `gtm.init_consent`
    gtag('consent', 'default', {
      'ad_storage': 'denied',
      'analytics_storage': 'denied',
      'ad_personalization': 'denied',
      'ad_user_data': 'denied',
    });

    // Push `gtm.init_consent` with default consent values
    window.dataLayer.push({
      event: 'gtm.init_consent',
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_personalization: 'denied',
      ad_user_data: 'denied',
    });

    // Dynamically load gtag.js if not already loaded
    if (!window.gtagInitialized) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=G-GN0TLTYTPS`;
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.gtagInitialized = true;
        // Initialize Google Analytics with the provided ID
        gtag('js', new Date());
        gtag('config', 'G-GN0TLTYTPS', { send_page_view: false });
      };
    }

    // Update consent settings dynamically based on user interaction
    gtag('consent', 'update', {
      'ad_storage': adsConsent ? 'granted' : 'denied',
      'analytics_storage': analyticsConsent ? 'granted' : 'denied',
      'ad_personalization': analyticsConsent ? 'granted' : 'denied',
      'ad_user_data': analyticsConsent ? 'granted' : 'denied',
    });

    // Push `gtm.update_consent` event with updated consent values
    window.dataLayer.push({
      event: 'gtm.update_consent',
      ad_storage: adsConsent ? 'granted' : 'denied',
      analytics_storage: analyticsConsent ? 'granted' : 'denied',
      ad_personalization: analyticsConsent ? 'granted' : 'denied',
      ad_user_data: analyticsConsent ? 'granted' : 'denied',
    });
  };

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsConsentGiven('true');
    initializeGoogleAnalytics(true, true); // Grant all permissions
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsConsentGiven('false');
    initializeGoogleAnalytics(false, false); // Deny all permissions
  };

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'true') {
      initializeGoogleAnalytics(true, true);
    } else if (consent === 'false') {
      initializeGoogleAnalytics(false, false);
    } else {
      // Default to denied if no prior consent is stored
      initializeGoogleAnalytics(false, false);
    }
  }, []);

  const getstatus= localStorage.getItem('cookieConsent');
  console.log("Consent Status:" , getstatus);
  return (
    <div
      className={`cookie-consent-banner ${
        isConsentGiven !== null ? 'no-padding' : ''
      }`}
    >
      {isConsentGiven === null && (
        <div className="cookie-banner">
          <p>
            We use cookies to enhance your browsing experience, serve
            personalized ads or content, and analyze our traffic. By clicking
            "Accept All", you consent to our use of cookies.
          </p>
          <div className="cookie-buttons">
            <button className="accept-btn" onClick={handleAccept}>
              Accept
            </button>
            <button className="decline-btn" onClick={handleDecline}>
              Decline
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CookieConsent;
